module.exports = __webpack_public_path__ + "img/MaidenofWaxInkBlue.9d1b694b.png";